import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AirdropTransactionsLayer from "../../components/AirdropCampagin/AirdropTransactionsLayer";

const AirdropTransactionsPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Airdrop Transactions" />
                    <AirdropTransactionsLayer />
               </MasterLayout>
          </>
     );
};

export default AirdropTransactionsPage;
